import React, { useEffect } from "react";
import { Stack, Typography } from "@mui/material";

import { HubDialogContent, HubHookFormWrapper } from "../../components";
import MergePartForm from "./MergePartForm";
import MergePartButtons from "./MergePartButtons";
import { useHubSnackBar, usePostMergePartData } from "../../hooks";
import { useDialogContext } from "../HubDialogWrapper";

const MergePartContent = () => {
  const {
    mutate: postMergePartData,
    isLoading,
    isSuccess,
    isError,
  } = usePostMergePartData();

  const { onClose = () => {} } = useDialogContext();
  const { addSnackbarError } = useHubSnackBar();

  useEffect(() => {
    isError && addSnackbarError({ title: "Error Merging Parts" });
  }, [isError]);

  useEffect(() => {
    isSuccess && onClose();
  }, [isSuccess]);

  const onSubmit = (formData) => {
    const payload = {
      id: formData.partId[0].id,
      ids: formData?.mergeParts?.map(({ id }) => id),
    };
    postMergePartData(payload);
  };

  return (
    <HubDialogContent largePadding>
      <HubHookFormWrapper onSubmit={onSubmit}>
        <Stack gap="20px" alignItems="center">
          <Stack alignItems="center" textAlign="center">
            <Typography variant="h6">Merge Parts</Typography>
            <Typography variant="caption" sx={{ width: "80%" }}>
              Select the main part then any parts you wish to merge. Any Line
              Items, Work Orders, History will be merged to the new part. Any
              routing from the old parts will be deleted.{" "}
              <strong>This cannot be undone!</strong>
            </Typography>
          </Stack>
          <MergePartForm disabled={isLoading} />
          <MergePartButtons disabled={isLoading} />
        </Stack>
      </HubHookFormWrapper>
    </HubDialogContent>
  );
};

export default MergePartContent;
